
import React from 'react';
import ReactQuill from 'react-quill';
import {css} from 'emotion';

export const FormEditBlockFieldHTML = function (props) {

  if (!props.block()?.component || props.block()?.component != 'HTML')
    return (<></>);

  return (<>
    <label
      className={css`
        display: flex;
        gap: 8px;
        padding: 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #d1d5db;
      `}
    >
      <div
        className={css`
          display: grid;
          place-content: start center;
          place-items: start center;
        `}
      >
        HTML
      </div>
      <div
        className={css`
          display: grid;
          place-content: stretch;
          place-items: center;
          width: 100%;
        `}
      >
        <ReactQuill
          className={css`
            width: 100%;
          `}
          // https://github.com/zenoamaro/react-quill?tab=readme-ov-file#props
          theme="snow"
          value={props.block()?.props?.html ?? ''}
          onChange={(html) => {
            props.block({
              ...props.block(),
              props: {
                ...props.block()?.props,
                html: html,
              },
            });
          }}
          modules={{
            toolbar: [
              // https://quilljs.com/docs/modules/toolbar/
              [{ header: [1, 2, 3, false] }],
              [{ 'size': ['small', false, 'large'] }],

              ['bold', 'italic', 'underline'],
              [{ 'color': [] }],
              // [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'indent': '-1'}, { 'indent': '+1' }], // outdent/indent
              ['link'], // insert/edit hyperlink
              [{ 'align': [] }], // align left/center/right
              // ['image'], // attach image
              // ['code', 'code-block'],
              ['blockquote'],
              ['clean'], // remove formatting button
            ],
          }}
          formats={[
            // https://quilljs.com/docs/formats/
            'header',
            'size',
            'bold', 'italic', 'underline',
            'color',
            'list',
            'indent',
            'link',
            'align',
            'image',
            // 'code',
            'blockquote',
          ]}
        />
      </div>
    </label>
  </>);

};
